import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const ClientPortalNetWorthPerformanceQuery = graphql(/* GraphQL */ `
  query ClientPortalNetWorthPerformance($portfolioId: ID, $householdId: ID) {
    portfolioPerformanceReport(portfolioId: $portfolioId, householdId: $householdId) {
      id
      performanceOverTime {
        timePeriod
        twr
        usdReturn
        startDate
        endDate
      }
    }
  }
`);

export type ClientPortalNetWorthPerformanceResult = ResultOf<typeof ClientPortalNetWorthPerformanceQuery>;

export type ClientPortalNetWorthPerformancePeriod =
  ClientPortalNetWorthPerformanceResult['portfolioPerformanceReport']['performanceOverTime'][number];
